module.exports = __webpack_public_path__ + "img/096.4f944096.jpg";